import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '600px',
    minHeight: '350px',
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100vw - 32px)',
    },
    '& .inputSelect': {
      width: 'calc(100% - 35px)',
    },
  },
  button: {
    float: 'right',
  },
  paper: {
    [theme.breakpoints.down('xs')]: {
      margin: '0px',
    },
    overflowx: 'clip',
  },
  formControl: {
    display: 'block',
    margin: '0 0',
    '&:first-child': {
      margin: '0 0 0 0',
    },
  },
  label: {
    width: '100%', // Labels have scale(0.75) applied to them, so this effectively makes the width 100%
  },
}));

export default function TermsAndConditionsDialog({
  open,
  onClose,
  onResult,
}: {
  open: boolean;
  onClose: () => void;
  onResult: (acceptTermsAndConditions: boolean) => void;
}) {
  const classes = useStyles();
  //const [termsAndConditions, setTermsAndConditions] = useState<boolean>(false);

  const onCloseClick = (acceptTermsAndConditions: boolean) => {
    onResult(acceptTermsAndConditions);
  };

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.paper }}>
      <DialogTitle>Terms and Conditions (community-based patients)</DialogTitle>
      <Divider />
      <DialogContent className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div>
              <div style={{ background: 'red', color: 'white', borderRadius: '5px', textAlign: 'center' }}>
                Has the patient been in a major accident?
                <br />
                Are they <u>unconscious</u> or <u>having chest pain</u>, <u>difficulty breathing</u> or{' '}
                <u>uncontrolled bleeding</u>:<br />
                <b>Please call “000” immediately</b>
              </div>
              <br />
              My Emergency Doctor provides services for acute medical conditions.
              <br />
              We are not a GP tele-service.
              <br />
              <br />
              <b>Please call “000” or refer to your GP</b>, if you, or the patient are:
              <ul>
                <li>
                  Requiring <b>mental health and counselling services.</b>
                </li>
                <li>
                  Requiring treatment for a <b>child younger than 1 month old.</b>
                </li>
                <li>
                  A child <b>under 16 of age without an adult</b> present.
                </li>
                <li>
                  Requiring{' '}
                  <b>prescriptions for S8 medications such as oxycodone (endone) and other drugs of dependence.</b>
                </li>
                <li>
                  Requiring <b>routine repeat prescriptions.</b>
                </li>
                <li>
                  Requiring <b>prescriptions for medications such as Ozempic (Semaglutide)</b>
                </li>
              </ul>
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          style={{ background: '#E22525', color: 'white' }}
          className={classes.button}
          variant="contained"
          onClick={() => onCloseClick(false)}
        >
          Cancel
        </Button>
        <Button
          className={classes.button}
          color="primary"
          variant="contained"
          //disabled={!termsAndConditions}
          onClick={() => onCloseClick(true)}
        >
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
}
